import type { ISelectionResult } from './ISelectionResult'

export default class MultiLegSelectionResult implements ISelectionResult {
  constructor(
    public leg: number,
    public selectionStrings: string[]
  ) {}
}
